import { Divider, type DividerProps } from "~/common/mui";

export type SearchInputGroupDividerProps = Omit<DividerProps, "orientation" | "flexItem">;

export const SearchInputGroupDivider = (props: SearchInputGroupDividerProps) => {
  return <Divider orientation="vertical" flexItem {...props} />;
};
